import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { VariantType, enqueueSnackbar, useSnackbar } from "notistack";
import { FC } from "react";
import { CloseSnackbarProps } from "../interfaceTypes";

export const CloseButton: FC<CloseSnackbarProps> = ({ id }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton
      color="inherit"
      size="small"
      onClick={() => closeSnackbar(id)}
      aria-label="close notification"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};

export const Alert = {
  success(message: string) {
    this.toast(message, "success");
  },
  warning(message: string) {
    this.toast(message, "warning");
  },
  info(message: string) {
    this.toast(message, "info");
  },
  error(message: string) {
    this.toast(message, "error");
  },
  toast(message: string, variant: VariantType = "default") {
    enqueueSnackbar(message, { variant });
  },
};
